<template>
  <div class="background" id="home">
    <div class="navimage">
      <div class="navbarwl">
        <div class="nav">
          <div id="navbar" :class="{ backgroundi: show }">
            <div class="nav-brand">
              <router-link to="/">
                <img
                  src="../assets/MaletaLogo.svg"
                  alt=""
                />
              </router-link>
              <b-icon-list
                scale="2"
                class="fa fa-navicon"
                v-on:click="display"
              ></b-icon-list>
            </div>

            <div class="bar-items" :class="{ hide: !show }">
              <div id="menu">
                <a href="#uber-uns"> Über uns </a>

                <a href="#services"> Dienstleistungen </a>

                <a href="#gut"> Standort </a>

                <a href="#footer"> Kontakt </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="center">
        <h1>Ein gezielter Weg zu Ihrem Recht</h1>
      </div>
      <VueSlickCarousel v-bind="settings">
        <div class="display">
          <div class="backgroundi">
            <img src="../assets/slide3.jpg" class="ikona" />
          </div>
        </div>
        <div class="display">
          <div class="backgroundi">
            <img src="../assets/slide4.jpg" class="ikona" />
          </div>
        </div>
        <div class="display">
          <div class="backgroundi">
            <img src="../assets/slide1.jpg" class="ikona" />
          </div>
        </div>
        <div class="display">
          <div class="backgroundi">
            <img src="../assets/slide2.jpg" class="ikona" />
          </div>
        </div>
      </VueSlickCarousel>
    </div>
    <div class="about">
      <h2>Über uns</h2>
      <p>
        MALETA Advokatur strebt danach, seine Klienten auf nationaler und
        internationaler Ebene erfolgreich zu beraten und zu betreuen. Die
        Zufriedenheit und die Interessen unserer Klientschaft stehen an erster
        Stelle. Fairness und Transparenz ist für uns entscheidend, weshalb wir
        grossen Wert auf persönliche Betreuung legen. Professionalität,
        Kundenorientierung und Flexibilität zeichnen uns aus. Die Kombination
        unseres Fachwissens mit dem jeweiligen Prozess- bzw. Verfahrensrecht
        ermöglicht es uns, eine optimale Beratung für Privatpersonen und
        Unternehmen anzubieten. In unseren Händen dürfen Sie sich wohl und
        sicher fühlen. Wir freuen uns auf Ihre Kontaktnahme.
      </p>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { Slide } from "vue-burger-menu"; // import the CSS transitions you wish to use, in this case we are using `Slide`

export default {
  components: { VueSlickCarousel },
  Slide,
  data() {
    return {
      settings: {
        arrows: false,
        dots: false,
        edgeFriction: 0.35,
        infinite: true,
        speed: 2000,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        responsive: [
          {
            breakpoint: 1440,
            settings: {
              speed: 2000,
              slidesToShow: 3,
              slidesToScroll: 1,
              autoplay: true,
              dots: false,
              arrows: false,
            },
          },
          {
            breakpoint: 1000,
            settings: {
              speed: 2000,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              dots: false,
              arrows: false,
            },
          },
          {
            breakpoint: 601,
            settings: {
              speed: 2000,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              dots: true,
              arrows: false,
            },
          },
        ],
      },
      show: false,
    };
  },
  methods: {
    display() {
      this.show = !this.show;
    },
  },
};
</script>

<style scoped>
.background {
  background-color: #f9f9f9;
  margin-bottom: 10%;
}

#navbar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: transparent;
  width: 100%;
  margin-top: 2%;
}

#menu {
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin: 0;
  padding: 0;
}

.bar-items {
}
.b-icon.bi {
  display: none;
}

a {
  padding: 20px;
}

li:hover {
  background-color: #42d392;
}

a {
  text-decoration: none;
  font-size: 18px;
  color: #fff;
}

.fa {
  display: none;
}
.ikona {
  width: 100%;
  height: 870px;
}

.navbarwl {
  display: flex;
  justify-content: space-between;
  /* padding: 0% 5%; */
  position: absolute;
  /* top: 50px; */
  z-index: 1;
  background: transparent;
  width: 100%;
}

.container-fluid {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.nav {
  display: flex;
  gap: 9%;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background: transparent;
}

.center {
  background: transparent;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 45%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.center h1 {
  color: white;
  font-size: 62px;
  font-weight: 700;
  line-height: 73px;
  font-family: "Rubik";
}

.navbarwl a {
  color: white;
  text-decoration: none;
  font-size: 18px;
  font-weight: 700;
  font-family: "Rubik";
}

.about {
  background-color: white;
  width: 70%;
  position: absolute;
  transform: translate(21.5%, -55%);
  text-align: left;
  padding: 40px 60px;
  -webkit-box-shadow: 60px 20px 31px -5px rgba(215, 215, 242, 1);
  -moz-box-shadow: 9px 6px 31px -14px rgba(215, 215, 242, 1);
  box-shadow: 12px 12px 31px -12px rgba(215, 215, 242, 1);
}

.about h2 {
  font-size: 45px;
  font-weight: 700;
  font-family: "Rubik";
}

.about p {
  font-size: 17px;
  font-weight: 400;
  line-height: 25px;
  font-family: "Rubik";
}

.nav-brand img{
  height: 80px;
}

@media screen and (min-width: 1001px) and (max-width: 1800px) {
  .nav {
    width: 100%;
  }

  .navbarwl {
    padding: 0% 0% 0% 3%;
  }

  .center {
    background: transparent;
    z-index: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .center h1 {
    color: white;
    font-size: 55px;
    font-weight: 700;
    line-height: 73px;
    font-family: "Rubik";
  }

  .about {
    background-color: white;
    width: 85%;
    position: absolute;
    transform: translate(9%, -55%) !important;
    text-align: left;
    padding: 20px 25px;
    -webkit-box-shadow: 60px 20px 31px -5px rgba(215, 215, 242, 1);
    -moz-box-shadow: 9px 6px 31px -14px rgba(215, 215, 242, 1);
    box-shadow: 12px 12px 31px -12px rgba(215, 215, 242, 1);
  }

  #navbar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: transparent;
  width: 100%;
  margin-top: 2%;
}
}

@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .ikona {
    width: 100%;
    height: 610px;
  }

  .center {
    background: transparent;
    z-index: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 35%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
}

@media screen and (max-width: 1000px) {
  .about {
    background-color: white;
    width: 85%;
    transform: translate(9%, -40%);
    text-align: left;
    padding: 20px 20px;
    -webkit-box-shadow: 60px 20px 31px -5px rgba(215, 215, 242, 1);
    -moz-box-shadow: 9px 6px 31px -14px rgba(215, 215, 242, 1);
    box-shadow: 12px 12px 31px -12px rgba(215, 215, 242, 1);
    margin-bottom: 10% !important;
  }

  .about h2 {
    font-size: 40px;
    font-weight: 700;
    font-family: "Rubik";
  }

  .about p {
    font-size: 15px;
    font-weight: 400;
    line-height: 25px;
    font-family: "Rubik";
  }

  .center h1 {
    color: white;
    font-size: 40px;
    font-weight: 700;
    line-height: 73px;
    font-family: "Rubik";
  }

  .ikona {
    width: 100%;
    height: 500px;
  }

  .center {
    background: transparent;
    z-index: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 30%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .b-icon.bi {
    display: inline-block;
  }
  #navbar {
    flex-direction: column;
    margin-top: 0px;
  }
  .backgroundi {
    background-color: #0446a7 !important;
  }
  .backroundi {
    background: cornflowerblue;
  }

  .fa {
    display: block;
    padding: 0 25px;
    position: absolute;
    right: 20px;
    color: #fff;
    font-size: 70px;
    cursor: pointer;
    margin-top: 30px;
  }

  #menu {
    flex-direction: column;
    padding: 5px 0;
  }

  #menu a {
    font-size: 14px;
  }

  a {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
  }

  .hide {
    display: none;
  }

  .nav-brand {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding: 15px 0px; */
  }

  .nav-brand img{
    height: 80px;
    margin-top: 10%;
  }

  .navbarwl {
    z-index: 2;
  }
}

/* @media screen and (min-width: 1000px) and (max-width: 1200px){
  .about{
    background-color: white;
    width: 90%;
    transform: translate(21.5%, -55%);
    text-align: left;
    padding: 20px 20px;
    -webkit-box-shadow: 60px 20px 31px -5px rgba(215,215,242,1);
    -moz-box-shadow: 9px 6px 31px -14px rgba(215,215,242,1);
    box-shadow: 12px 12px 31px -12px rgba(215,215,242,1);
  }
} */

@media screen and (min-width: 320px) and (max-width: 600px) {
  .background {
    background-color: #f9f9f9;
    margin-bottom: -70%;
  }

  /* .backgroundi{
    display: none;
  }

  .display{
    background-image: url('../assets/bird2.svg');
    height: 650px;
    background-repeat: no-repeat;
    width: 100%;
    background-size: cover;
  } */

  .ikona {
    width: 100%;
    height: 420px;
  }
  .center {
    background: transparent;
    z-index: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 27%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .center h1 {
    color: white;
    font-size: 32px;
    font-weight: 700;
    line-height: 73px;
    font-family: "Rubik";
  }

  .about {
    background-color: white;
    width: 90%;
    transform: translate(5%, -18%);
    position: relative;
    text-align: left;
    padding: 20px 20px;
    -webkit-box-shadow: 60px 20px 31px -5px rgba(215, 215, 242, 1);
    -moz-box-shadow: 9px 6px 31px -14px rgba(215, 215, 242, 1);
    box-shadow: 12px 12px 31px -12px rgba(215, 215, 242, 1);
    margin-bottom: 15% !important;
  }

  .logo {
    display: flex;
    justify-content: center;
  }

  .navbarwl {
    display: flex;
    justify-content: space-between;
    z-index: 2;
  }

  .b-icon.bi {
    display: inline-block;
  }
  #navbar {
    flex-direction: column;
    margin-top: 0px;
  }
  .backgroundi {
    background-color: #0446a7 !important;
  }
  .backroundi {
    background: cornflowerblue;
  }

  .fa {
    display: block;
    padding: 0 25px;
    position: absolute;
    right: 20px;
    z-index: 1;
    color: #fff;
    font-size: 70px;
    cursor: pointer;
    margin-top: 30px;
  }

  #menu {
    flex-direction: column;
    padding: 5px 0;
  }

  a {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
  }

  .hide {
    display: none;
  }

  .nav-brand {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding: 15px 0px; */
  }

  .nav-brand img{
  height: 60px;
}
}
</style>
